///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm = abcsetup.three_pm || {};
abcsetup.three_pm.price_change_resubmission = abcsetup.three_pm.price_change_resubmission || {};
abcsetup.three_pm.price_change_resubmission.create = abcsetup.three_pm.price_change_resubmission.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm.price_change_resubmission.create = {

    init: function() {

        $(document).on('change keyup', 'input.resubmit-check', function(e) {
            let checkboxes = document.querySelectorAll('input[type=checkbox]:checked').length;
            
            if ($(this).prop("checked")) {
                $(this).val("true");
            } else {
                $(this).val("false");
            }

            if (checkboxes > 0) {
                $('#resubmit-button').prop('disabled', false);
            } else {
                $('#resubmit-button').prop('disabled', true);
            }
        });

        $('#resubmit-button').on('click', function(e) {
            let checkboxes = document.querySelectorAll('input[type=checkbox]:checked').length;
            if (checkboxes === 0) {
                e.preventDefault();
                confirm('You must select at least one item.');
            }
        });

        $('#check-all-button').on('click', function(e) {
            $("input:checkbox").each(function() {
                $(this).prop("checked", true);
                $(this).val("true");
            });
        });

        $('#reset-selections-button').on('click', function(e) {
            $("input:checkbox").each(function() {
                $(this).prop("checked", false);
                $(this).val("false");
            });
        })

        /**
         * Paginator
         */
        $('#load-more-button').on('click', function (e) {
            let new_count = parseFloat($('#load-count').val()) + parseFloat(10);
            $('#load-count').val(new_count);
            hideRows(true);
            for (let i = (new_count - 10); i < new_count; i++) {
                $('#'+i).removeClass('hide');
            }
            triggerInputs();
        });

        $('#load-all-button').on('click', function (e) {
            $("table > tbody > tr").each(function () {
                $(this).show();
            });
        })

        $('#reset-load-more-button').on('click', function (e) {
            $('#load-count').val(10);
            hideRows()
        });

        function hideRows(show = false) {
            $("table > tbody > tr").each(function () {
                if (show) {
                    $(this).show();
                }
                if (parseFloat($(this).attr('id')) > parseFloat($('#load-count').val()) - 1) {
                    $(this).hide();
                }
            });
        }

        function triggerInputs() {
            $("table > tbody > tr.not-rendered").each(function () {
                if (!$(this).hasClass('hide')) {
                   //$(this).find('input.price_field').trigger('change'); 
                   $(this).removeClass('not-rendered');
                }
            });
        }

        triggerInputs();
    }

}